import UploadValidationDataStore from '@/data/datastores/UploadValidationDataStore';

export default class UploadValidationDataStoreMock
  implements UploadValidationDataStore
{
  async uploadValidation() {
    return {
      valor: '14',
      resultado: '1|Tamaño in (kb) within range (14)',
      idParametroValidacion: '00000000-0000-0000-0000-000000000000',
      valorMinimo: '4',
      valorMaximo: '50',
      idParametro: 'b4962003-7630-4324-8cf7-bb47a499867f',
      orden: 1,
      tipoCaracteristica: 1,
      nombre: 'Tamaño',
      unidad: '50kb',
      tipoValor: 1
    };
  }
}
